import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

// Initialize locale settings based on machine locale
import { initializeMachineLocale } from "./HelperClasses/LocaleHelper";
initializeMachineLocale();
//locale id is determined by the browser settings
//For dev we pass it as a startup param to chrome from LaunchSettings
// console.log('Machine locale:', getMachineLocale());
// console.log('Moment locale:', getMomentLocale());
// console.log('Current moment locale:', moment.locale());

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
